export interface Kasa {
  ksid: number
  pin: number
  rentedAt?: string
  rentedScd: number
  rentedSpotName: string
}

export interface LastAction {
  ikasaId: string
  ksid: number
  processId: string
  processedAt: string
  spotName: string
}

export interface LastReturnAction extends LastAction {
  rentedAt: string
}

// It names very strange
// レンタル・返却申請確認が必要な対象
// https://docs.i-kasa.com/api/http/v2.html#/paths/~1share~1request~1ikasa_id~1{ikasa_id}/get
export interface ShareRequestPayload {
  currentShares: Kasa[] | null
  needSelect: boolean
  rental: LastAction | null
  return: LastReturnAction | null
}

export type ShareRequestConfirmContent = {
  time: string
  spotName: string
  ksid: number
  processId: string
} & ({ action: 'rental' } | { action: 'return'; rentedAt: string })

export function parseStandUrl(url: string) {
  return new URL(url).searchParams.get('id')
}
